import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import StarIcon from '../../../../../Cutesies/StarIcon';
import ModalStore from '../../../../../Modal/Store';
import LearningCollectionEditStore from '../../../Edit/Store';
import BrowseAllToggle from '../../../LearningCollectionSteps/BrowseAllToggle';

interface Props {
  store: LearningCollectionEditStore;
  execonlineCatalogModalStore: ModalStore;
  warnUser: () => boolean;
}

function BrowseAll({ store, execonlineCatalogModalStore, warnUser }: Props) {
  return (
    <div
      className={clsx(
        'rounded-md border border-solid border-gray-200 bg-white px-5 py-4',
        'flex items-center justify-between',
      )}
    >
      <StarIcon />
      <p className="ml-3 grow text-sm">
        <T
          kind="Participants can access the <span>Essentials catalog</span> with this collection"
          span={(translated) => (
            <span
              className="cursor-pointer font-semibold underline"
              onClick={execonlineCatalogModalStore.open}
            >
              {translated}
            </span>
          )}
        />
      </p>
      <BrowseAllToggle store={store} warnUser={warnUser} />
    </div>
  );
}

export default observer(BrowseAll);
